export function getPayType (code) {
  let payType = ''
  switch (code) {
    case 4:
      payType = 'oneTimePayment'
      break
    case 3:
      payType = 'perYear'
      break
    case 2:
      payType = 'perHalfYear'
      break
    case 1:
      payType = 'perSeason'
      break
    case 0:
      payType = 'perMonth'
      break
  }
  return payType
}

export const statusColor = {
  Inforce: '#00BD9A',
  Terminated: '#CCCCCC',
  UnderReview: '#00B9F2',
  ReviewCompleted: '#052F6D',
  Withdrawn: '#F7605C'
}

export const getDetailTagColor = {
  policy: {
    1: statusColor.Inforce,
    2: statusColor.Terminated
  },
  application: {
    1: statusColor.UnderReview,
    2: statusColor.ReviewCompleted,
    3: statusColor.Withdrawn
  }
}
